document.addEventListener("DOMContentLoaded", () => {

  const button = document.getElementById("ScrollToTop");

  if (!button) return;

  const toggleButton = () => {
    button.classList.toggle("visible", window.scrollY > 400);
  };

  toggleButton();

  window.addEventListener("scroll", toggleButton);

  button.addEventListener("click", () => {

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

  });

});